import { Outlet } from 'react-router'
import Layout from '../components/Layout'
import { ProtectedRoute } from '../components/ProtectedRoute'

export function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <Layout>
        <Outlet />
      </Layout>
    </ProtectedRoute>
  )
}
